import { STXAxiosInstance } from '../Axios/STXAxiosInstance';
import { useTokenStorage } from '../store';
import { StxChain } from '../types/api/ApiResponseTypes';
import { getStorageKeysForNetwork } from '../utils/LocalstorageUtils';

const { setToken } = useTokenStorage();

export const login = async ({
  signature,
  address,
  publicKey,
  network,
  setAddress,
}: {
  signature: string;
  address: string;
  publicKey: string;
  network: string;
  setAddress: (address: string) => void;
}) => {
  // console.log(`signature2:${signature}, address:${address}, publicKey:${publicKey}`);
  try {
    const response = await STXAxiosInstance.post('/auth', { signature, address, publicKey });
    const token = response.data.data;
    const storageKeys = getStorageKeysForNetwork();
    setToken(token.jwtToken);
    localStorage.setItem(storageKeys.asignaRefresh, token.refreshToken.refreshToken);
    STXAxiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token.jwtToken}`;
    localStorage.setItem(storageKeys.testnetAddress, token.testNetAddress);
    localStorage.setItem(storageKeys.mainnetAddress, token.mainNetAddress);
    setAddress(
      network === StxChain.STX_MAINNET_CHAIN ? token.mainNetAddress : token.testNetAddress
    );
  } catch (error) {
    console.error(error);
    setAddress('');
    const storageKeys = getStorageKeysForNetwork();
    localStorage.setItem(storageKeys.testnetAddress, '');
    localStorage.setItem(storageKeys.mainnetAddress, '');
  }
};
